import { BASE_URL } from "@/services/api/base";

export const getSubContractorsEndpoint = `${BASE_URL}/LoaContractors/GetSubContractors`;
export const getUpdateSubContractorEndpoint = `${BASE_URL}/LoaContractors/UpdateSubContractor`;

export const getSubContractorByNameEndpoint = `${BASE_URL}/LoaContractors/GetSubContractorsByNameUnifedId`;

export const getCreateSubContractorEndpoint = `${BASE_URL}/LoaContractors/AddSubContractor`;
